import moment from 'moment'

export default {
	data() {
		return {
			selectedQuantity: '0 st',
			quantityArray: [
				{ id: 0, text: '0 st' },
				{ id: 1, text: '1 st' },
				{ id: 2, text: '2 st' },
				{ id: 3, text: '3 st' },
				{ id: 4, text: '4 st' },
				{ id: 5, text: '5 st' },
				{ id: 6, text: '6 st' },
				{ id: 7, text: '7 st' },
				{ id: 8, text: '8 st' },
				{ id: 9, text: '9 st' },
				{ id: 10, text: '10 st' }
			]
		}
	},
	created: function () {},
	methods: {
		convertToBool(value) {
			if (value) {
				return true
			} else {
				return false
			}
		},

		//Set image/fallback image
		getImgUrl(image, type) {
			if (type == 'array') {
				if (image == null || image.length == 0) {
					return ['https://boka.klappen.se/images/klappen_boende_fallback.jpg']
				} else {
					if (image[0].img == '') {
						return [
							'https://boka.klappen.se/images/klappen_boende_fallback.jpg'
						]
					} else {
						return image[0].img
					}
				}
			} else {
				if (image == '') {
					return 'https://boka.klappen.se/images/klappen_boende_fallback.jpg'
				} else {
					return image
				}
			}
		},

		//Replace "\r\n", "\r" or "\n" with "<br>"
		convertLineBreak(string) {
			return string.replace(/(?:\r\n|\r|\n)/g, '<br>')
		},

		//Format price: '1 595'
		convertPrice(price) {
			return new Intl.NumberFormat(this.$t('currency')).format(price)
		},

		convertDateSpanToId(fromdate, todate) {
			if (todate == undefined) {
				todate = fromdate
			}
			fromdate = todate.replace(/-/g, '')
			todate = todate.replace(/-/g, '')
			const spandate = fromdate + todate
			return Number(spandate)
		},

		//Format date: '27 february'
		formatDateWithYear(date) {
			moment.locale(this.$t('locale'))
			return moment(date).format('D MMM YYYY')
		},

		//Format date: '27 february'
		formatDate(date) {
			moment.locale(this.$t('locale'))
			return moment(date).format('D MMMM')
		},

		//Format day: 'monday'
		formatDay(day) {
			moment.locale(this.$t('locale'))
			return moment(day).format('dd')
		},

		//Format weekday: 'mon'
		formatWeekday(weekday) {
			return weekday.slice(0, 3)
		},

		//Format date: '27 - 28 february 2021' or '27 february - 3 march 2021' or '29 december 2020 - 3 january 2021'
		formatDateSpan(startdate, enddate) {
			if (typeof enddate == 'number') {
				if (enddate > 1) {
					enddate = moment(startdate).add(enddate - 1, 'days')
				} else {
					enddate = startdate
				}
			}

			if (!enddate) {
				enddate = startdate
			}

			moment.locale(this.$t('locale'))
			var startdateMonth = moment(startdate).format('MMMM')
			var enddateMonth = moment(enddate).format('MMMM')
			var startdateYear = moment(startdate).format('YYYY')
			var enddateYear = moment(enddate).format('YYYY')
			var startdateDay = moment(startdate).format('D')
			var enddateDay = moment(enddate).format('D')
			var spandate = ''
			if (startdateYear == enddateYear) {
				if (startdateMonth == enddateMonth) {
					if (startdateDay == enddateDay) {
						spandate = moment(enddate).format('D MMMM YYYY')
					} else {
						spandate =
							moment(startdate).format('D') +
							'-' +
							moment(enddate).format('D MMMM YYYY')
					}
				} else {
					spandate =
						moment(startdate).format('D MMMM') +
						'-' +
						moment(enddate).format('D MMMM YYYY')
				}
			} else {
				spandate =
					moment(startdate).format('D MMMM YYYY') +
					'-' +
					moment(enddate).format('D MMMM YYYY')
			}
			return spandate
		},

		//Format date: '27-28 feb'
		formatDateSpanShort(startdate, enddate) {
			if (typeof enddate == 'number') {
				if (enddate > 1) {
					enddate = moment(startdate).add(enddate - 1, 'days')
				} else {
					enddate = startdate
				}
			}

			if (!enddate) {
				enddate = startdate
			}

			moment.locale(this.$t('locale'))
			var startdateMonth = moment(startdate).format('MMMM')
			var enddateMonth = moment(enddate).format('MMMM')
			var spandate = ''
			if (startdateMonth == enddateMonth) {
				spandate =
					moment(startdate).format('D') + '-' + moment(enddate).format('D MMM')
			} else {
				spandate =
					moment(startdate).format('D MMM') +
					'-' +
					moment(enddate).format('D MMM')
			}
			return spandate
		},

		//Return diff in number of days between dates
		dateDiff(startDate, endDate) {
			var a = moment(endDate)
			var b = moment(startDate)
			return a.diff(b, 'days') + 1
		},

		dayordays(amont) {
			return amont == 1 ? this.$t('day') : this.$t('days')
		},

		//Format age: '7-10 year' or '7 year'
		formatAgeSpan(minage, maxage) {
			var spanage = ''
			if (minage == maxage) {
				spanage = minage + ' ' + this.$t('years')
			} else {
				if (maxage == '99' || maxage == '95') {
					spanage = minage + '+ ' + this.$t('years')
				} else {
					spanage = minage + '-' + maxage + ' ' + this.$t('years')
				}
			}
			return spanage
		},

		formatMoney(price) {
			return new Intl.NumberFormat(this.$t('currency')).format(price)
		},

		//Get level name (bas, medel, avancerad) based on level ID
		getLevelName(id) {
			return this.levels.find(each => each.id == id).label
		},

		toLowerCase(string) {
			return string.toLowerCase().trim()
		}
	}
}
